import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function StatSquare({
  icon = "fa-face-smile",
  label = "Total Asistentes",
  value = 445,
  change = null,
  iconBg = "bg-white",
  iconColor = "text-blue-400",
  dataSwapItem = "item-1",
  pillColor = "bg-green-200",
}) {
  return (
    <div
    data-swapy-item={`${dataSwapItem}`}
     className="group relative flex items-center rounded-2xl bg-aw-bluedark p-3 w-full h-full shadow-lg">
      {/* <div data-swapy-handle className="absolute top-0 right-1 cursor-grab active:cursor-grabbing p-1 rounded-full text-gray-500 group-hover:text-gray-200 hover:bg-aw-bluedark/50 hover:text-white transition">
        <FontAwesomeIcon icon="fa-solid fa-up-down-left-right" />
      </div> */}
      <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${iconBg} mr-4`}>
        <FontAwesomeIcon icon={`fa-solid ${icon}`} size="lg" className={`${iconColor}`} />
      </div>
      <div className="flex-1 flex flex-col justify-center">
        <div className="text-white text-sm mb-1">{label}</div>
        <div className="text-2xl text-white leading-none">{value}</div>
      </div>
      {change !== null && (
      <div className="ml-4 flex h-full items-end">
        <span className={`${pillColor} text-aw-bluedark text-sm px-4 py-1 rounded-lg`}>
          {change > 0 ? "+" : ""}{change}%
        </span>
      </div>
      )}
    </div>
  );
}
